<template>
    <section>
    <div class="identification d-flex justify-center align-center ">
     <div class="logInOut pt-3 pb-2 rounded pl-2 pr-2">
     <AppLogin v-if="this.$store.state.login" />
     <AppSignUp v-else />
     <v-overlay opacity=".7" absolute z-index="0"></v-overlay>
     </div>
     </div>
     <AppFooter />
    </section>
</template>

<script>
import AppLogin from '@/components/loginout/Login.vue';
import AppSignUp from '@/components/loginout/SignUp.vue';
import AppFooter from '@/components/footer/Footer.vue';

export default {
    name:'loginout',
    data() {
        return {
            login:false
        }
    },
    components:{
        AppLogin,
        AppSignUp,
        AppFooter
    },
    beforeRouteLeave (to, from, next) {
        this.$store.state.login=true;
        next();
    }
}
</script>

<style lang="scss" scoped>
    .identification{
        min-height: 80vh;
        background-image: url('./../assets/backgrounds/login/loginBg.jpg');
        background-size: cover;
        background-repeat: no-repeat;
        .logInOut{
            width: 50%;
            position: relative;
        }
    }
    @media (max-width:600px){
        .logInOut{
            width: 90% !important;
        }
    }
    @media (min-width: 600px) and (max-width:960px){
        .logInOut{
            width: 80% !important;
        }
    }
</style>